import profile_img from '../../assets/images/pages/defaultImage.jpg';
import '../../assets/styles/pages.scss'
import { Link, useNavigate } from 'react-router-dom';
import React, { Fragment, useContext } from 'react';
import { GlobalContext, handleError } from '../../context/Provider';
import henceforthApi from '../../utils/henceforthApi';
import VerifyOtp from '../../components/modals/VerifyEmailOtp';
import authAction from '../../context/authAction';
import { toast } from 'react-toastify';

const Profile = () => {
    const { language_data, authState, authDispatch, loading, setLoading } = useContext(GlobalContext)
    const [openEmailVerification, setOpenEmailVerification] = React.useState(false)
    const navigate = useNavigate()
    
    const initialiseProfile = async (data: any) => {
        try {
            let apiRes = await henceforthApi.Auth.emailVerifyOtp({ otp: data, language: 'ENGLISH' })
            console.log('apiRes------', apiRes);
            authAction.initialiseProfile(apiRes.data)(authDispatch);
            setOpenEmailVerification(false)
        } catch (err) {
            handleError(err, 'active', authDispatch)
        }
    }

    const resendEmailOtp = async () => {
        if (loading) return
        setLoading(true)
        try {
            let items = {
                email: authState.email,
                language: "ENGLISH"
            }
            let apiRes = await henceforthApi.Auth.emailVerifySendOtp(items)
            return apiRes.data
        } catch (error: any) {
            handleError(error, 'active', authDispatch)
        } finally {
            setLoading(false)
        }
    }

    const OpenEmailVerification = async() => {
        await resendEmailOtp()
        setOpenEmailVerification(true)
    }

    const handleResubmitProfile = async () => {
        setLoading(true)
        try {
            const apiRes = await henceforthApi.Auth.resubmitProfile()
            
            if (apiRes?.data) {
                authAction.initialiseProfile(apiRes.data)(authDispatch)
                toast.success('Profile resubmitted successfully! Your account is now under review.')
            }
        } catch (error: any) {
            console.error('Resubmit profile error:', error)
            
            if (error?.response?.body?.error === 'ALREADY_PENDING') {
                toast.warning(
                    'Your profile is already pending verification. Please wait for admin review.'
                )
            } else {
                handleError(error, 'active', authDispatch)
            }
        } finally {
            setLoading(false)
        }
    }

    // Helper function to get image URL
    const getImageUrl = (image: string | null | undefined) => {
        if (!image) return profile_img;
        return image.endsWith('.webp') 
            ? `${henceforthApi.API_FILE_ROOT_ORIGINAL}${image}` 
            : `${henceforthApi.API_FILE_ROOT_MEDIUM}${image}`;
    }

    // Helper function to get document image URL
    const getDocumentImageUrl = (image: string | null | undefined) => {
        if (!image) return profile_img;
        return image.endsWith('.webp') 
            ? `${henceforthApi.API_FILE_ROOT_ORIGINAL}${image}` 
            : `${henceforthApi.API_FILE_ROOT_MEDIUM}${image}`;
    }

    console.log('authState', authState)

    return (
        <Fragment>
            {/* breadcrum  */}
            <section className="breadcrum-box">
                <div className="container-fluid">
                    <div className="row">
                        <div className="col-md-12">
                            <h2>{language_data?.[authState.lang]?.common_profile}</h2>
                            <nav aria-label="breadcrumb">
                                <ol className="breadcrumb m-0">
                                    <li className="breadcrumb-item"><Link to="/">{language_data?.[authState.lang]?.common_home}</Link></li>
                                    <li className="breadcrumb-item active fw-bold">{language_data?.[authState.lang]?.common_profile}</li>
                                </ol>
                            </nav>
                        </div>
                    </div>
                </div>
            </section>

            {/* page  */}
            <div className='page-spacing'>
                <section className='seller-profile'>
                    <div className="container-fluid">
                        <div className="row justify-content-center">
                            <div className="col-12 mb-4">
                                {authState.is_admin_verified === 'reject' && (
                                    <div className="alert alert-danger p-4 rounded-3 border-0 shadow-lg" role="alert" style={{ borderLeft: '5px solid #dc3545' }}>
                                        <div className="d-flex align-items-start">
                                            <div className="alert-icon-wrapper me-3 flex-shrink-0">
                                                <div className="alert-icon-circle bg-danger bg-opacity-10 rounded-circle d-flex align-items-center justify-content-center" style={{ width: '60px', height: '60px' }}>
                                                    <i className="fa fa-times-circle text-danger" style={{ fontSize: '32px' }}></i>
                                                </div>
                                            </div>
                                            <div className="alert-content flex-grow-1">
                                                <h5 className="alert-heading fw-bold mb-2 text-danger">
                                                    {'Account Verification Rejected'}
                                                </h5>
                                                <p className="mb-3 text-muted">
                                                    {'Your seller account has been rejected by the administrator. Please review the reason below and make necessary corrections.'}
                                                </p>
                                                
                                                {(authState as any)?.rejection_reason && (
                                                    <div className="rejection-reason-box bg-white rounded-3 p-3 mb-3 border-start border-4 border-danger">
                                                        <h6 className="fw-bold mb-2 text-dark">
                                                            <i className="fa fa-info-circle text-danger me-2"></i>
                                                            {'Rejection Reason:'}
                                                        </h6>
                                                        <p className="mb-0 text-dark">{(authState as any)?.rejection_reason}</p>
                                                    </div>
                                                )}
                                                
                                                <div className="alert-actions d-flex flex-wrap gap-2 mt-3">
                                                    <button 
                                                        className="btn btn-danger px-4 py-2 fw-semibold" 
                                                        onClick={() => navigate('/profile/edit')}
                                                    >
                                                        <i className="fa fa-edit me-2"></i>
                                                        {'Edit & Resubmit Profile'}
                                                    </button>
                                                    <button 
                                                        className="btn btn-outline-danger px-4 py-2 fw-semibold" 
                                                        onClick={handleResubmitProfile}
                                                        disabled={loading}
                                                    >
                                                        <i className="fa fa-refresh me-2"></i>
                                                        {'Resubmit Without Changes'}
                                                    </button>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                )}
                                {authState.is_admin_verified === 'pending' && (
                                    <div className="alert alert-warning d-flex align-items-center p-4 rounded-3 border-0 shadow-sm" role="alert">
                                        <i className="fa fa-clock-o fa-3x me-3 text-warning"></i>
                                        <div>
                                            <h5 className="alert-heading fw-bold mb-1">Verification Pending</h5>
                                            <p className="mb-0">Your account is currently under review by our administrators. We'll notify you once your account is verified.</p>
                                        </div>
                                    </div>
                                )}
                            </div>

                            <div className="col-sm-9 col-md-5 col-lg-4 col-xl-4 col-xxl-3 px-0">
                                {/* Title  */}
                                <div className="common-card h-100">
                                    <div className="common-card-title">
                                        <h5>{language_data?.[authState.lang]?.common_my}{language_data?.[authState.lang]?.common_profile}</h5>
                                    </div>
                                    {/* Profile  */}
                                    <div className="common-card-content">
                                        {/* Profile image  */}
                                        <div className="profile-image">
                                            <img 
                                                src={getImageUrl(authState?.image)} 
                                                alt={authState?.image || 'Profile'} 
                                                className='' 
                                            />
                                        </div>
                                        
                                        {/* Profile Detail  */}
                                        <div className="profile-image my-4">
                                            <h5 className='mb-3'>{authState.name}</h5>
                                            <p className="d-flex align-items-center mb-1">
                                                <i className='fa fa-envelope me-2 fs-5'></i>
                                                {authState.email} &nbsp;
                                                {authState.email_verified ? (
                                                    <i className="fa fa-check text-success" aria-hidden="true"></i>
                                                ) : (
                                                    <i className="fa fa-exclamation-triangle text-danger" aria-hidden="true" onClick={OpenEmailVerification}></i>
                                                )}
                                            </p>
                                            <p className="d-flex align-items-center mt-2">
                                                <i className='fa fa-phone-square me-2 fs-5'></i>
                                                +{authState.country_code} {authState.phone_number}
                                            </p>
                                            <p className="d-flex align-items-start mt-2">
                                                {authState.full_address ? <i className='fa fa-map-marker me-2 fs-5'></i> : ''}
                                                {authState.full_address}
                                            </p>
                                        </div>
                                        
                                        {(authState as any).admin_commission && (
                                            <p className="d-flex align-items-start mb-2">
                                                <i className='fa fa-percent me-2 fs-5'></i>
                                                {'Commission ' + (authState as any).admin_commission || 0}%
                                            </p>
                                        )}
                                        
                                        {/* button  */}
                                        <div className="profile-button">
                                            <Link to="/profile/edit" className='btn btn-theme w-100'>
                                                {language_data?.[authState.lang]?.common_edit} {language_data?.[authState.lang]?.common_profile}
                                            </Link>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            {/* Bank Details section */}
                            <div className="col-sm-9 col-md-5 col-lg-4 col-xl-4 col-xxl-3 px-0 ms-0 ms-md-4 mt-4 mt-md-0">
                                <div className="common-card h-100">
                                    <div className="common-card-title">
                                        <h5>Bank Details</h5>
                                    </div>
                                    <div className="common-card-content d-flex flex-column justify-content-center align-items-center py-5">
                                        {authState?.is_bank_added ? (
                                            <Fragment>
                                                <div className="mb-4 text-success text-center">
                                                    <i className="fa fa-check-circle fa-4x mb-3 text-success"></i>
                                                    <h5 className="text-dark">Bank Details Added</h5>
                                                    <p className="text-muted small">Your bank information is securely stored.</p>
                                                </div>
                                                <button
                                                    onClick={() => navigate('/profile/bank-details')}
                                                    className="btn btn-theme px-5"
                                                >
                                                    <i className="fa fa-edit me-1"></i> Edit/View Details
                                                </button>
                                            </Fragment>
                                        ) : (
                                            <Fragment>
                                                <div className="mb-4 text-warning text-center">
                                                    <i className="fa fa-university fa-4x mb-3 text-muted opacity-50"></i>
                                                    <h5 className="text-dark">No Bank Account</h5>
                                                    <p className="text-muted small px-3">Please add your bank details to enable product listing and payments.</p>
                                                </div>
                                                <button
                                                    onClick={() => navigate('/profile/bank-details')}
                                                    className="btn btn-theme px-5"
                                                >
                                                    <i className="fa fa-plus-circle me-1"></i> Add Bank Details
                                                </button>
                                            </Fragment>
                                        )}
                                    </div>
                                </div>
                            </div>

                            {/* Documents section */}
                            {(authState as any)?.documents && Array.isArray((authState as any).documents) && (authState as any).documents.length > 0 && (
                                <div className="col-12 px-0 mt-4">
                                    <div className="common-card">
                                        <div className="common-card-title">
                                            <h5>{'Documents'}</h5>
                                        </div>
                                        <div className="common-card-content">
                                            <div className="row">
                                                {(authState as any).documents.map((doc: any) => (
                                                    <div className="col-md-6 col-lg-4 mb-4" key={doc._id}>
                                                        <h6 className="text-capitalize fw-bold mb-3">
                                                            {doc.type.replaceAll(/_/g, ' ')}
                                                        </h6>
                                                        <div className="row g-2">
                                                            {doc.images && typeof doc.images === 'object' && (
                                                                <>
                                                                    {/* Front Image */}
                                                                    {doc.images.front && (
                                                                        <div className="col-6">
                                                                            <div className="document-image-wrapper border rounded overflow-hidden" style={{ height: '150px' }}>
                                                                                <img 
                                                                                    src={getDocumentImageUrl(doc.images.front)} 
                                                                                    alt={`${doc.type} front`}
                                                                                    className="w-100 h-100"
                                                                                    style={{ objectFit: 'cover', cursor: 'pointer' }}
                                                                                    onClick={() => window.open(getDocumentImageUrl(doc.images.front), '_blank')}
                                                                                />
                                                                                <small className="text-muted d-block text-center mt-1">Front</small>
                                                                            </div>
                                                                        </div>
                                                                    )}
                                                                    {/* Back Image */}
                                                                    {doc.images.back && (
                                                                        <div className="col-6">
                                                                            <div className="document-image-wrapper border rounded overflow-hidden" style={{ height: '150px' }}>
                                                                                <img 
                                                                                    src={getDocumentImageUrl(doc.images.back)} 
                                                                                    alt={`${doc.type} back`}
                                                                                    className="w-100 h-100"
                                                                                    style={{ objectFit: 'cover', cursor: 'pointer' }}
                                                                                    onClick={() => window.open(getDocumentImageUrl(doc.images.back), '_blank')}
                                                                                />
                                                                                <small className="text-muted d-block text-center mt-1">Back</small>
                                                                            </div>
                                                                        </div>
                                                                    )}
                                                                </>
                                                            )}
                                                        </div>
                                                    </div>
                                                ))}
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            )}

                            {openEmailVerification &&
                                <VerifyOtp verifyCallback={initialiseProfile} resendOtpCallback={resendEmailOtp} onCloseModal={setOpenEmailVerification} />
                            }
                        </div>
                    </div>
                </section>
            </div>
        </Fragment>
    )
}

export default Profile;